import {PieChart} from '@mui/x-charts/PieChart';
import "./PieChartWithPaddingAngle.scss"
import {convertCurrencyFormatPositiveNegative} from "@moeindal/base-raiko-panel-components";
import {useEffect, useState} from "react";


export default function PieChartWithPaddingAngle(
    {
        data = []
    }
) {
    const [total, setTotal] = useState(0)

    useEffect(() => {
        if (typeof data !== "undefined") {
            setTotal(0)
            data.map((item) => {
                setTotal(prevTotal => prevTotal + item.value)
            })
        }
    }, [data]);

    return (
        <div className={"basePieChartWithPaddingContainer"}>
             <span className={"labelContainer"}>
                {convertCurrencyFormatPositiveNegative(total)}
            </span>
            <div className={"pieChartWithPaddingContainer"}>
                <PieChart
                    series={[
                        {
                            startAngle: -90,
                            endAngle: 90,
                            paddingAngle: 1,
                            innerRadius: 70,
                            outerRadius: 100,
                            cornerRadius: 5,
                            data,
                        },
                    ]}
                    margin={{right: 5}}
                    width={200}
                    height={200}
                    slotProps={{
                        legend: {hidden: true},
                    }}
                />
            </div>

        </div>

    )
}

export const chartColors = {
    blue: "#16B1FF",
    purple: "#5752D1",
    light_purple: "#8481DD",
    red: "#FF4C51",
    cyan: "#73C5C5",
    green: "rgb(2,178,131)",
    gold: "#F4C145",
    orange: "#EF9234",
    gray: "#B8BBBE",
    light_gray: "#F0F0F0",
}

export function preparePieChartItem(label, value, color = chartColors.blue) {
    return {
        label,
        value,
        color
    }
}
